export default __webpack_public_path__ + "static/media/Opposites01_01.bc61b975.png";